import { Component, inject } from '@angular/core';
import { FlexModule } from '@ngbracket/ngx-layout';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { RouterLink } from '@angular/router';
import { APP_CONFIG } from '@core/config/app-config.token';
import { injectBrand } from '@core/config/brand';

@Component({
  selector: 'recrewt-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [FlexModule, ExtendedModule, RouterLink],
})
export class FooterComponent {
  private appConfig = inject(APP_CONFIG);

  readonly brand = injectBrand();

  readonly currentYear = new Date().getFullYear();

  readonly footerSrc = this.appConfig.modules.home.footerImageSrc;

  readonly fundedBySrc = this.appConfig.modules.home.fundedByImageSrc;
}
